import moment from 'moment-timezone'

export const filterProductRows = (rows, selectedIds) =>
  rows.filter((row) => selectedIds.has(String(row.id)))

export const hasTransactionValue = (row) =>
  Number(row?.purchase?.totalAfterVAT || 0) !== 0 ||
  Number(row?.sales?.totalAfterVAT || 0) !== 0

export const summarizeProductRows = (rows) => {
  const makeSide = (side) => {
    const byName = new Map()
    let transactionCount = 0
    rows.forEach((row) => {
      const value = Number(row?.[side]?.totalAfterVAT || 0)
      transactionCount += Number(row?.[side]?.transactionCount || 0)
      byName.set(row.name, (byName.get(row.name) || 0) + value)
    })
    const items = Array.from(byName, ([name, totalAfterVAT]) => ({ name, totalAfterVAT }))
    return {
      totalAfterVAT: items.reduce((sum, item) => sum + item.totalAfterVAT, 0),
      transactionCount,
      items,
    }
  }
  const purchase = makeSide('purchase')
  const sales = makeSide('sales')
  return { purchase, sales, difference: {
    totalAfterVAT: sales.totalAfterVAT - purchase.totalAfterVAT,
    transactionCount: sales.transactionCount - purchase.transactionCount,
  } }
}

export const buildFilteredYearSummary = (yearMonthRows, selectedItemIds) => {
  const months = yearMonthRows.map((rows, index) => {
    const summary = summarizeProductRows(filterProductRows(rows.filter(hasTransactionValue), selectedItemIds))
    return { month: index + 1, label: moment().month(index).format('MMMM'), ...summary }
  })
  const totals = summarizeProductRows(yearMonthRows.flatMap((rows) => filterProductRows(rows.filter(hasTransactionValue), selectedItemIds)))
  const monthSide = (side) => months.map((month) => ({
    month: month.month,
    label: month.label,
    totalAfterVAT: month[side].totalAfterVAT,
    transactionCount: month[side].transactionCount,
  }))
  return {
    purchase: { ...totals.purchase, months: monthSide('purchase') },
    sales: { ...totals.sales, months: monthSide('sales') },
    difference: { ...totals.difference, months: monthSide('difference') },
  }
}
